<template>
  <div v-if="!user.key"
       class="ut-p-10">
    <loading-spinner class="ut-mt-0" />
  </div>
  <div v-else>
    <div  v-if="isProspectingAgent">
      <div v-if="!loadingProspect" class="ut-container-lg">
        <prospect-header :prospect="prospect"
          :userid="agent.userid"
          :loading="activities.loading || loadingProspect">
        </prospect-header>
        <prospect-stage-questions v-if="!loadingProspect" :userid="agent.userid" />

        <prospect-activity-section :activities="activities.data"
          :contact="prospect.contact"
          :loading="activities.loading" />

        <prospecting-remove-prospect-modal v-if="!loadingProspect" :agentId="agent.id"/>
      </div>
      <div v-else
          class="ut-p-10">
        <loading-spinner class="ut-mt-0" />
      </div>
    </div>
    <div v-else>
      {{ notFoundRedirect() }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ProspectActivitySection from '@/components/Prospecting/ProspectActivitySection.vue';
import ProspectHeader from '@/components/Prospecting/ProspectHeader.vue';
import ProspectStageQuestions from '@/components/Prospecting/ProspectStageQuestions.vue';
import ProspectingRemoveProspectModal from '@/components/Modals/ProspectingRemoveProspectModal.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';

export default {
  name: 'Prospect',
  components: {
    ProspectHeader,
    ProspectActivitySection,
    ProspectStageQuestions,
    ProspectingRemoveProspectModal,
    LoadingSpinner,
  },
  data() {
    return {
      loadingProspect: false,
      loadingActivities: false,
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      prospect: state => state.prospectStore.prospect,
      activities: state => state.prospectStore.activities,
    }),
    ...mapGetters('userStore', [
      'isProspectingAgent',
    ]),
  },
  created() {
    // If this is the Prospect Route
    if (!this.prospect || this.prospect.key !== this.$route.params.pk) {
      this.loadingProspect = true;
      this.loadingActivities = true;
      this.getProspect(this.$route.params.pk);
    }
  },
  methods: {
    ...mapActions('prospectStore', [
      'loadProspect',
      'loadProspectActivities',
    ]),
    getProspectActivity(contactKey, prospectKey) {
      const payload = {
        prospectKey,
        contactKey,
      };

      this.loadProspectActivities(payload).then(() => {
        this.loadingActivities = false;
      });
    },
    getProspect(prospectKey) {
      const payload = {
        prospectKey,
      };

      this.loadProspect(payload).then(() => {
        this.getProspectActivity(this.prospect.contact.key, this.prospect.key);
        this.loadingProspect = false;
      });
    },
    notFoundRedirect() {
      this.$router.push({
        name: '404',
        params: { ak: this.$route.params.ak },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
